import ResumenPagos from "../../pagos-alumnos/ResumenPagos";
import ResumenAlumno from "./subComponents/ResumenAlumno";
import CardCursoTraslado from "./subComponents/CardCursoTraslado.js";
import React, { useState, useEffect } from "react";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import Resumen from "./subComponents/Resumen";
import WarningModal from "../../components-modals/WarningModal";
import Total from "./subComponents/Total";
import { formatearFechaASinDiagonales } from "../../tools/ConversionFechas";
import { SUCURSALES } from "../utils/constants";
import {
  getCursos, getSedes, postCursos,
  //  guardarCursos
} from "../api/";
import Cursos from "./Cursos";
import { CircleDashedLogo } from "../../components-layout/Logos";
import { getCatalogos } from "../api/";

const TrasladoCursos = ({ urlCursos, state, send, headers, respuesta, setLoading, pathname, IdEmp }) => {


  console.log(state.context.seleccionados, 'state.context.seleccionados')
  const [modal, setModal] = useState({
    ok: false,
    show: false,
    msg: ""
  })

  const [cursos, setCursos] = useState([]);

  const [sede, setSede] = useState("");
  const [idCurso, setIdCurso] = useState("");
  const [verCursos, setVerCursos] = useState(false)
  const [nombreVisible, setNombreVisible] = useState(true)
  const [sedeNombre, setSedeNombre] = useState("")
  const [contador, setContador] = useState(0)

  const [catalogos, setCatalogos] = useState()



  const sedesIds = (id) => {
    const opcion = {
      '51': () => "SJ",
      '52': () => "PT",
      '54': () => "AB",
      '55': () => "Z6",
      '56': () => "SC",
      '57': () => "VN",
      '58': () => "NJ",
      '59': () => "VD",
    }
    return opcion[id]()
  }

  const handleOpen = (idCurso) => {
    setIdCurso(idCurso)
    setVerCursos(true)

    // getCursos(send, headers, idCurso, sede)
    // send, headers, idCurso, idSede
    // send("ABRIR", { headers:headers, idCurso:idCurso, sede:sede })
  }

  const handleAdd = (index) => {
    send("SELECCIONAR", { seleccionado: state.context.datos[index] });
    send("QUITAR_DE_DATOS", { seleccionado: state.context.datos[index] });
  };


  const setNoCobrados = (array) => { // no lo estoy mandando bien, debo mandar todo, no solo los cargos
    const cursos1 = array.map(curso => {
      const cobrados = curso.Cargos.filter(cargo => !cargo.Cobrado)
      //console.log(cobrados)
      curso.Cargos = cobrados
      return curso
    })
    //console.log('cursos::', cursos1)
    return cursos1
  };

  const guardarCursosSeleccionados = () => {
    let cursos = []
    const datosString = JSON.stringify(state.context.seleccionados)
    const datos = JSON.parse(datosString)  // copia  de arrays

    //const datos = JSON.parse(state.context.seleccionados)
    datos.forEach(element => { // yyyymmdd
      element.De = formatearFechaASinDiagonales(element.De)
      element.A = formatearFechaASinDiagonales(element.A)
      if (element.Header) {

        // const filtro = state.context.seleccionados.filter(el => el.Key === element.Key)//.filter(el => !el?.Cobrado) // filtrados
        const filtro = datos.filter(el => el.Key === element.Key)
        //      console.log('FILTRO::::', filtro)
        // codigo pra la limpieza del filtro, quitar sobrantes o poner faltantes
        // enviar el conjunto de arrays pero ya completo, padre con sus hijos
        const completo = element.Header
        completo.Cargos = filtro
        cursos.push(completo)
      }
    })
    console.log('CURSOS:::', cursos)
    // const cursosFiltrados = setNoCobrados(cursos)
    const cursosFiltrados = cursos;
    const dataEnviar = {
      "Carnet": state.context.carnet,
      "IdSolicitud": parseInt(state.context.solicitud),
      "Cursos": { "Cursos": cursosFiltrados },
      "CursosAntes": state.context.CursosAntes,
      "HostName": "DEV07",
      "IpHost": "131.107.1.235",
      "IdEmp": IdEmp,// puede ser extraído del usuario público
      "OS": "Windows"
    }
    // llamar a la funcion que va a ejecutar send("ACEPTAR")
    postCursos(urlCursos, headers, dataEnviar, setModal, send, setLoading, state.context.datosUsuario.Modalidad)
  }




  const handleDelete = (index) => {

    // send("QUITAR_DE_RESUMEN", { quitar: index });
    /* 
    1- tomar el key del item seleccionado
    2- filtrar los elementos por el key
    3- crear un bucle en el cual se toma la orden en adelante para eliminar los items con el numero de orden mayor al del item seleccionado
    */
    const cursosCopia = [...cursos]

    const seleccionado = state.context.seleccionados[index]
    const indexCurso = seleccionado?.IndexCurso
    const indexHorario = seleccionado?.IndexHorario
    // const indexCargo   = seleccionado.IndexCargo

    // usar some para ver si el padre o alguno de sus padres está Pagado: 0  REVISAR

    const key = state.context.seleccionados[index].Key

    const selectedSameOrder = state.context.seleccionados.filter(element => element.Key === key)
    //console.log('selectedSameOrder', selectedSameOrder)
    const seleccionadosLength = selectedSameOrder.length
    const inicio = state.context.seleccionados[index].Orden
    //console.log('seleccionado', seleccionado)
    //console.log('cursosSopia', cursosCopia)

    console.log('dfaasdfasdfasd', cursosCopia)
    console.log('indexCurso:', indexCurso)
    console.log('indexHorario:', indexHorario)

    if (cursosCopia[indexCurso].Horarios[indexHorario].Cargos.some(cargo => cargo.Pagado)) {
      setModal({
        ok: false,
        show: true,
        msg: "No se puede quitar el cargo seleccionado, ya que fue un cargo relacionado fuepagado"
      })
      // no dejar que se quite
    } else {
      // quitar

      for (let ix = inicio - 1; ix < seleccionadosLength; ix++) {
        // console.log('borrar: ', selectedSameOrder[ix])
        // quitar a nivel de elementos, con filter, ya no mediante indices
        console.log("quitar", selectedSameOrder[ix])
        send("QUITAR", { quitar: selectedSameOrder[ix] });
        try {
          cursosCopia[indexCurso].Horarios[indexHorario].Cargos[ix].Seleccionado = false
        } catch (error) {
          console.log(error)
        }
      }
    }
  };


  const handleSede = (value, nombreSede) => {
    setSede(() => value)
    send("GUARDAR_SEDE", { sede: value })
    // send("GUARDAR_NOMBRESEDE", { nombreSede: nombreSede });
  }


  const getCatalogosresponse = async () => {
    const catalogos = await getCatalogos(urlCursos, send, headers, state.context?.datosUsuario?.Modalidad);
    setCatalogos(catalogos.msg)
    console.log('CATALOGUITOSdfasdfhasjdhfkj::', catalogos)
    send("CARGAR_CATALOGOS", { catalogos: catalogos.msg });

  }


  useEffect(() => {
    getSedes(urlCursos, send, headers)
    // //setSede(() => state.context.seleccionados.Cursos[0]["IdSede"])
    console.log('context traslado', state)
    // console.log('FORMASPAGO:', state.context.formaspago)
    // console.log('CURSOS: ', state.context.seleccionados) //.Cursos[0]["IdSede"])
    // getCatalogosresponse()

  }, [])

  const showOptions = () => {
    setModal({
      ok: false,
      show: true,
      msg: "Se perderán los datos seleccionados. ¿Desea volver atrás?",
      showOptions: true
    })
  }

  /*
  useEffect(() => {
    if(respuesta === "CANCELAR"){
      console.log('respuesta: ', respuesta)
       send("CANCELAR");
       
      
      setModal({
        show:false
      })
    }
  
  }, [respuesta])
  */



  return (
    <div>

      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >

        <div className="mt-5 sm:mt-6">
          {modal.showOptions ?
            <div className='flex flex-row justify-between'>
              <button
                onClick={() => { (pathname === '/campus/centro') ? send("CANCELAR") : send("CANCELAR_2") }}
                // onClick={() => window.location.reload()}
                className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >Atrás</button>
              <button
                onClick={() => setModal({ show: false })}
                className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
              >Cancelar</button>
            </div>
            :
            <button
              onClick={() => {
                if (modal.reload) {
                  window.location.reload();
                }
                setModal((curr) => ({
                  ...curr,
                  show: false,
                  reload: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >
              Entendido
            </button>
          }
        </div>

      </WarningModal>

      {/*
      <select>
        {state.context.datos?.map((element, index) => (
          <option key={index} value={element?.name}>{element?.name}</option>
        ))}
      </select>
        */}
      <div className="sm:flex w-full sm:flex-col lg:flex-row">

        <div className={"xl:p-2 w-full"}>{/* "flex lg:w-3/4 sm:w-full flex-col rounded-md shadow-sm shadow-white my-2 " */}
          {/* {!verCursos &&
            <> */}
          {/* <div className={"flex  m-auto lg:flex-row flex-col xl:justify-center "}> */}
          {/* <select className="lg:w-1/2 rounded-md w-full" value={state.context.sede} onChange={(e) => handleSede(e.target.value)}> */}
          {/* {state.context.sedes.map(element => (
                  <>
                    <div className="flex flex-row">
                      <div
                        className={state.context.sede === element['IdSede'] ?
                          "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 bg-azulBrillanteMira hover:shadow-md hover:shadow-white" :
                          "grid m-1 w-20 h-20 rounded-full ring-azulBrillanteMira  ring-1 hover:bg-azulBrillanteMira hover:shadow-md hover:shadow-white"}
                        onClick={() => handleSede(element['IdSede'], element.Nombre)}
                        onMouseEnter={() => setSedeNombre(element.Nombre)}
                      >
                        <p className="m-auto text-white text-2xl font-bold">{sedesIds(element['IdSede'])}</p>
                      </div>
                      <p className="block lg:hidden m-auto text-white">{element.Nombre}</p>
                    </div>
                  </>
                ))}

                <div className={"flex lg:w-1/2 w-full flex-col"}>
                  <p className="text-secundario m-auto hidden xl:inline p-2">Para continuar, es importante que elija una sede, ya que esta elección le permitirá acceder a los catálogos de cursos disponibles en dicha sede.</p>
                  {nombreVisible ? <p className={"m-auto text-white hidden xl:flex"}>{sedeNombre}</p> : null}
                </div>
              </div> */}
          {/**/}
          <ResumenAlumno
            urlCursos={urlCursos}
            datosInscripcion={state.context.datosUsuario}
            carnet={state.context.carnet} />
          {/* </>
          } */}
          {/* <div className="text-center p-2">
            <p className=" text-secundario m-auto inline xl:hidden">Debe seleccionar una sede para acceder a los catálogos de cursos que posee la misma</p>
          </div> */}
          <CardCursoTraslado
            urlCursos={urlCursos}
            state={state}
            //data={state.context.seleccionados}
            data={state.context.cursos}
            send={send}
            handleClick={handleOpen}
            textoBoton={"Ver cursos disponibles"}
            id="IdCurso"
            value="NombreCurso"
          />
        </div>
        {/* <div className={"flex lg:w-1/4 sm:w-full flex-col pr-4 mx-auto"}>
          {state.context.seleccionados.length > 0 && (
            <Resumen
              // data={seleccionados}
              urlCursos={urlCursos}
              data={state.context.seleccionados}
              handleDelete={handleDelete}
            // handleCupon={handleCupon}
            />
          )}
          {state.context.seleccionados.length > 0 && (
            <div className="p-2">
              <Total urlCursos={urlCursos} send={send} data={state.context.seleccionados} guardarCursosSeleccionados={guardarCursosSeleccionados} />
            </div>
          )}
        </div> */}
      </div>
      <div className="flex flex-row justify-between p-2">
        <button
          className={"p-2 text-white bg-azulBrillanteMira rounded-md"}
          onClick={() => verCursos ? setVerCursos(false) : showOptions()} // preguntar si se va para atras o no con un dialogo, advirtiendo que se perderan los cambios en los cursos seleccionados
        >
          Atrás
        </button>
      </div>
    </div>
  );
};

export default TrasladoCursos;
